import { Avatar, Button, Divider, Grid, TextField, Typography } from "@material-ui/core";
import ChatIcon from "@material-ui/icons/Chat";
import TitleContainer from "~/components/common/titleContainer/TitleContainer";
import WhatsAppLoginButton from "~/components/common/whatsappLogin";
import SEO from "~/components/seo";
import dayjs from "~/config/dayjs";
import Utils from "~/helpers/Utils";
import bookingTransactionService, { getOneBookingTransaction, checkSlotBookingTransaction } from "~/services/bookingTransactionService";
import businessService from "~/services/businessService";
import checkoutServices from "~/services/checkoutServices";
import payPaymentService from "~/services/payPaymentService";
import { DialogBuilder } from "~/utils/DialogProvider";
import { useApiErrorModal } from "~/contexts/ApiErrorModalContext";
import { getApiErrorConfig, isAdvanceNoticeError } from "~/utils/apiErrorMessages";
import { mixpanelTrackEvent } from "~/utils/mixpanel";
import { getBookingOrigin } from "~/utils/bookingOrigin";
import { TIPO_ATENDIMENTO } from "~/utils/appointmentType";
import _ from "lodash";
import React, { Fragment, useEffect, useMemo, useRef, useState } from "react";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import checkUserPackageSessionsAction from "~/store/actions/checkUserPackageSessionsAction";
import { withRouter } from "react-router-dom";
import { isAppointmentLimitError, isProfessionalWithNoAgendaError } from "~/utils/checkout/errorsValidation";
import { fetchAlternativeSlotsForService } from "~/utils/checkout/alternativeSlots";
import useDateFormatter from "~/hooks/useDateFormatter";
import timeIcon from "assets/icons/group-4.png";
import { useCheckoutBookingErrorHandler } from "~/hooks/checkout/useCheckoutBookingErrorHandler";
import DialogAddCard from "../common/dialog/dialogAddCard";
import DialogDiscount from "../common/dialog/dialogDiscount";
import dialogPayCod from "../common/dialog/dialogPayCod";
import DialogPayConfirm from "../common/dialog/dialogPayConfirm";
import DialogPix from "../common/dialog/dialogPix";
import { ModalBottom } from "../common/modalBottom/modalBottom";
import PaymentSummary from "../common/paymentSummary";
import PackagePaymentSummary from "../common/paymentSummaryPackage/PaymentSummary";
import ServiceItem from "../common/serviceItem";
import SelectedPackageInfo from "../common/selectedPackageInfo";
import useStyles from "./styles";
import { useCheckoutPackageOffer } from "~/hooks/useCheckoutPackageOffer";
import dialogPayConfirmPackage from "../common/dialog/dialogPayConfirmPackage";
import { activePaymentPackage, isValidCheckout, roundPricesDown } from "~/utils/checkout/price";
import { getPackageServiceIds } from "~/utils/checkout/packages";
import { calculateStandaloneServicesAnticipation } from "~/utils/checkout/anticipation";
import useCheckSessionPackage from "~/hooks/useCheckSessionPackage";
import usePolicyActive from "~/hooks/usePolicyActive";
import CheckoutSessionPackageModal from "./CheckoutSessionPackageModal";
import CheckoutSessionPackageContainer from "./CheckoutSessionPackageContainer";
import { useContract } from "~/contexts/ContractContext";
import { usePolicyCancellation } from "~/contexts/PolicyCancellationContext";
import ModalPhoneNumber from "../common/ModalPhoneNumber";
import ModalUserName from "../common/ModalUserName";
import { useWhatsAppAuthContext } from "~/contexts/WhatsAppAuthContext";
import { getContrastColor, getInitials } from "~/utils/business";
import ModalPaymentProcessing from "../common/ModalPaymentProcessing";
import { handleBreadcrumb } from "~/utils/handleError";
import LinhaPacote from "~/components/common/linhaPacote/LinhaPacote";
import PackageOfferModal from "~/components/common/packageOfferModal/PackageOfferModal";
import { buildSessionAcceptedFromChoice, calculateReviewValues, canOfferPackagePurchase, canOfferPendingPackage, formatDateDDMMYYYY, getEligibleClientPackages } from "~/utils/packages";
import { buildPackageCheckoutPayload } from "~/utils/checkout/packages";

const Checkout = (props) => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const observationTextField = useRef(null);
	const hasLoadedCheckoutData = useRef(false);
	const { business } = useSelector((store) => store.business);
	const businessRef = useRef(business);
	useEffect(() => { businessRef.current = business; }, [business]);
	const { user } = useSelector((store) => store.auth);
	const meStore = useSelector((store) => store.me?.me);
	const me = Utils.safeParseJSON("@prit-web/meData", meStore);
	const userIdStorage = localStorage.getItem("@prit-web/userId");
	const dialog = useContext(DialogBuilder);
	const { showApiError } = useApiErrorModal();
	const { i18n, t } = useTranslation();
	const storageLanguage = sessionStorage.getItem("@prit-web/language");
	const language = storageLanguage ?? business?.language;
	const { authStatus, setAuthStatus, openModalCustom } = useWhatsAppAuthContext();
	const { loadContract } = useContract();
	const { getPolicyCancellation, loadPolicyCancellation } = usePolicyCancellation();

	const [contract, setContract] = useState();
	const [checkoutInformation, setCheckoutInformation] = useState(null);
	const [checkoutInformationPackage, setCheckoutInformationPackage] = useState(null);
	const [loading, setLoading] = useState(false);
	const [isProcessing, setIsProcessing] = useState(false);
	const [isPackageActivating, setIsPackageActivating] = useState(false);
	const [whatsAppLoading, setWhatsAppLoading] = useState(false);
	const [showLogin, setShowLogin] = useState(localStorage.getItem("@prit-web/showLogin") || false);
	const showLoginGoogle = !business ? false : business?.gmailClient;

	const [errorObservation, setErrorObservation] = useState(false);
	const [observation, setObservation] = useState("");
	const [characterCount, setCharacterCount] = useState(0);

	const [cardData, setCardData] = useState();
	const [pix, setPix] = useState();
	const [pixCode, setPixCode] = useState();
	const pixIntervalRef = useRef(null);
	const pixUnblockRef = useRef(null);
	const [showUpdateInfo, setShowUpdateInfo] = useState(false);
	const [offerAccepted, setOfferAccepted] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");
	const [showError, setShowError] = useState(false);
	const [isFirstLoginAfterRedirect, setIsFirstLoginAfterRedirect] = useState(false);
	const [showPaymentProcessingModal, setShowPaymentProcessingModal] = useState(false);
	const [showPhoneModal, setShowPhoneModal] = useState(false);
	const [showUserNameModal, setShowUserNameModal] = useState(false);
	const [packageModalQueue, setPackageModalQueue] = useState([]);
	const [packageModalQueueIndex, setPackageModalQueueIndex] = useState(0);
	const [packageModalDeclinedCount, setPackageModalDeclinedCount] = useState(0);
	const [userDeclinedPackage, setUserDeclinedPackage] = useState(false);
	// key = índice original em `services`; guarda o estado de recuperação de horários
	// expirados por antecedência mínima (ver isAdvanceNoticeError)
	const [serviceRecoveryState, setServiceRecoveryState] = useState({});
	const { formatTime, formatDateToLanguage } = useDateFormatter();
	const formatDateByLanguage = formatDateToLanguage();
	const [phoneModalConfig, setPhoneModalConfig] = useState({
		titleKey: "Complete your phone",
		messageKey: "You logged in with Google We need your number to send confirmations via WhatsApp",
	});

	const {
		setSelectedServices,
		availablePackages: reduxAvailablePackages,
		recommendedPackages: reduxRecommendedPackages,
		loadAvailablePackages,
	} = useCheckoutPackageOffer();

	const { updateScheduleSession, sessionsAccepted, clearSessionsAccepted, sessionsPackagesAvailable } = useCheckSessionPackage();
	const isPolicyActive = usePolicyActive();
	const isSessionPending = sessionsAccepted?.length > 0 && sessionsAccepted[0]?.infoPackage?.paymentStatus === "pending" && isPolicyActive;

	const storedPayload = JSON.parse(localStorage.getItem("@prit-web/checkoutPayload"));
	const currentBusinessId = props.match?.params?.id;
	if (storedPayload?._businessId && storedPayload._businessId !== currentBusinessId) {
		localStorage.removeItem("@prit-web/checkoutPayload");
	}
	const payload = (!storedPayload?._businessId || storedPayload._businessId === currentBusinessId)
		? storedPayload
		: null;

	const services = props?.location?.state?.services || payload?.services || [];
	const questions = props?.location?.state?.questions || payload?.questions || [];
	const recipientId = props?.location?.state?.recipientId || payload?.recipientId || props?.location?.state?.recipient_id;
	const coupon = props?.location?.state?.coupon || payload?.coupon;
	const bookingId = props?.location?.state?.bookingId || payload?.bookingId;
	const reschedule = props?.location?.state?.reschedule || payload?.reschedule;
	const postPayment = props?.location?.state?.postPayment || payload?.postPayment;
	const schedulingServicePackage =
		props?.location?.state?.schedulingServicePackage || payload?.schedulingServicePackage;
	const reservationUpdate = props?.location?.state?.reservationUpdate || payload?.reservationUpdate;
	const packageSessionInfo = props?.location?.state?.packageSessionInfo || payload?.packageSessionInfo;
	const isSchedulingPackageSession = schedulingServicePackage && !!reservationUpdate && !isSessionPending;
	const selectedPackages = props?.location?.state?.selectedPackages || payload?.selectedPackages;
	const infoPackage = props?.location?.state?.infoPackage || payload?.infoPackage;
	// Fluxo novo de oferta (SelectScheduleTime): "anonymous" | "logged" | undefined
	const packageFlow = props?.location?.state?.packageFlow;
	const rawClientPackages = props?.location?.state?.clientPackages || [];
	const packageChoices = props?.location?.state?.packageChoices || {};
	const [trocarServiceId, setTrocarServiceId] = useState(null);
	const [trocarSelectedPkgIdx, setTrocarSelectedPkgIdx] = useState(null);
	const laterPayment = props?.location?.state?.laterPayment || payload?.laterPayment;
	// `slotChecked: true` é injetado pelo SelectScheduleTime ao navegar para o checkout
	// via fluxo normal. Ausência indica acesso direto à URL.
	const slotChecked = props?.location?.state?.slotChecked === true;

	// `services` é recalculado a cada render a partir do location.state/payload, não é
	// state — por isso horários trocados após um erro de antecedência mínima vivem em
	// `serviceRecoveryState` e são mesclados aqui, sem mutar `services` diretamente.
	const effectiveServices = services.map((service, originalIndex) => {
		const override = serviceRecoveryState[originalIndex];
		if (override?.status === "updated" && override?.newDate) {
			const updated = { ...service, date: override.newDate, dateStart: override.newDate };
			if (override.newProfessionalId) {
				updated.professional_id = override.newProfessionalId;
			}
			return updated;
		}
		return service;
	});

	// Serviço coberto por sessão de pacote não gera booking próprio: vira update da
	// sessão. Os demais (avulsos) seguem o fluxo padrão de booking e pagamento.
	const sessionServiceIds = new Set([
		...Object.keys(packageChoices).filter((serviceId) => packageChoices[serviceId]?.type === "client"),
		...(sessionsAccepted || []).map((session) => String(session?.serviceId)),
	]);
	const standaloneServices = effectiveServices.filter((service) => !sessionServiceIds.has(String(service.service_id)));
	const sessionServicesKey = [...sessionServiceIds].sort().join(",");
	const hasOnlyPackageSessions = sessionsAccepted?.length > 0 && standaloneServices.length === 0;

	const currency = business?.currency || "BRL";

	const totalPricingType = Utils.getTotalPricingType(services);

	const couponCheck = localStorage.getItem("@prit-web/NoCoupon");
	const verificationUserIsNotAnonymous = user && !user?.isAnonymous;
	const startedLoggedOut = useRef(sessionStorage.getItem('@prit-web/schedulingStartedLoggedOut') === 'true').current;

	const colorBackgroundStorage = sessionStorage.getItem("@prit/colorBackground");
	const colorTextContrast = colorBackgroundStorage && getContrastColor(colorBackgroundStorage);

	const serviceNamesSelected = services
		.map((s) => s.service.serviceName)
		.sort((a, b) => a.localeCompare(b))
		.join(", ");
	const serviceDateSelected = services
		.map((s) => s.date)
		.map((d) => new Date(d).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric" }))
		.join(", ");
	const serviceTimesSelected = services
		.map((s) => s.date)
		.map((d) => new Intl.DateTimeFormat("pt-BR", { hour: "2-digit", minute: "2-digit" }).format(new Date(d)))
		.join(", ");
	const professionalsSelected = services?.map((s) => s?.professional?.name)
		.filter(Boolean)
		.sort((a, b) => a.localeCompare(b))
		.join(", ")
	const totalValuePrices = services?.reduce((acc, service) => { acc += service?.servicePrice || service?.professional?.price || 0; return acc; }, 0);
	const eventProps = {
		Servicos_Selecionados: serviceNamesSelected,
		Data_Selecionada: serviceDateSelected,
		Horario_Selecionado: serviceTimesSelected,
		Profissional_Selecionado: professionalsSelected,
		Valor_Total: totalValuePrices / 100
	};

	const currentUser = me || meStore?.me|| user || {};
	const isOwnerUser =
		!_.isEmpty(currentUser?.id) && !_.isEmpty(business?.ownerId) && currentUser.id === business.ownerId;

	const buildAnticipationRequest = (svcList) => {
		const request = {
			recipient_id: recipientId || business?.id,
			services: svcList.map((service) => ({
				date: dayjs(service.date).utc().format(),
				service_id: service.service_id,
				professional_id: service.professional_id,
				professional: {
					price:
						service.service.servicePrice > service.professional.price
							? service.service.servicePrice
							: service.professional.price,
					pricing_type: service.professional.pricingType,
				},
			})),
		};
		if (couponCheck) {
			request.coupon_id = coupon?.coupon?.coupon_id;
		}
		return request;
	};

	// Só os avulsos entram no valor antecipado; sem avulsos, mantém o cálculo com todos
	const servicesForAnticipation = () => (standaloneServices.length > 0 ? standaloneServices : services);
	// A escolha entre sessão e avulso pode mudar com um cálculo em andamento: a
	// requisição usa sempre a lista mais recente e só a resposta mais nova vale
	const latestAnticipationServices = useRef(servicesForAnticipation());
	latestAnticipationServices.current = servicesForAnticipation();
	const anticipationRequestSeq = useRef(0);

	const updateAcceptedSessions = () =>
		Promise.all(
			sessionsAccepted.map((session) =>
				updateScheduleSession(session).catch((error) => {
					console.error("Erro ao atualizar sessão:", session, error);
					throw error;
				})
			)
		);

	const anticipatedAmountCheckout = async (request) => {
		const seq = ++anticipationRequestSeq.current;
		try {
			const { data } = await checkoutServices.getAnticipatedAmountCheckout(request);
			if (seq !== anticipationRequestSeq.current) return;
			let format = {
				total_value_for_services: infoPackage?.info?.packagePrice,
				total_discounts: 0,
				anticipation_payment: infoPackage?.info?.packagePrice,
				amount: infoPackage?.info?.packagePrice,
				cancellation_policy: data?.use_cancellation_policy,
			};

			setCheckoutInformationPackage(format);
			setCheckoutInformation((prev) => ({
				...prev,
				...data,
			}));

		} catch (err) {
			if (err?.response?.status === 401) {
				localStorage.setItem("goBackRoute", JSON.stringify("/checkout/" + business.id));
				props.history.push(`/business/link/${business.id}`, {
					goBackRoute: "/checkout/" + business.id,
					goBackRouteProps: props.location.state,
				});
			}
			if (showApiError(err, null, null, { services, valor_agendamento: checkoutInformation?.total_value_for_services })) return;
			const errorMessage = err?.response?.data?.message || "";
			dialog
				.withMessage(`${errorMessage} Tente novamente!`)
				.withAction(() => window.location.reload())
				.show();
		}
	};

	useEffect(() => {
		const goBackRoute = Utils.safeLocalGet("goBackRoute");
		const autoScheduleSource = Utils.safeLocalGet("@prit-web/checkoutAutoSchedule");

		if (
			goBackRoute 
			&& goBackRoute.includes("/checkout/") 
			&& me?.name && 
			user && 
			!user.isAnonymous &&
			autoScheduleSource === "sms"
		) {
			setIsFirstLoginAfterRedirect(true);
			localStorage.removeItem("goBackRoute");
			localStorage.removeItem("@prit-web/checkoutAutoSchedule");
		}
	}, [me?.name, user]);

	useEffect(() => {
		if (selectedPackages && services) {
			isValidCheckout(selectedPackages, services);
		}
	}, [selectedPackages, services]);

	useEffect(() => {
		if (services?.length > 0) {
			const selectedServicesForAnalysis = services.map((service) => ({
				id: service.service_id,
				serviceName: service.service?.serviceName,
				price: service.service?.servicePrice || service.professional?.price,
				...service.service,
			}));

			setSelectedServices(selectedServicesForAnalysis);
		}
	}, [services?.length, setSelectedServices]);

	// Escolhas "usar meu pacote" feitas antes do checkout viram sessionsAccepted,
	// que o checkout já sabe agendar e cobrar (pacote pendente).
	const syncSessionsFromChoices = (choices) => {
		clearSessionsAccepted();
		const sessions = Object.keys(choices || {})
			.filter((serviceId) => choices[serviceId]?.type === "client")
			.map((serviceId) => {
				const service = effectiveServices.find((s) => String(s.service_id) === String(serviceId));
				return buildSessionAcceptedFromChoice(choices[serviceId], service);
			})
			.filter(Boolean);
		if (sessions.length > 0) {
			dispatch(checkUserPackageSessionsAction.sessionsAccepted(sessions));
		}
	};

	useEffect(() => {
		syncSessionsFromChoices(packageChoices);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	// "Trocar" precisa das ofertas do negócio — após recarregar a página, o store volta vazio
	useEffect(() => {
		if (!packageFlow || !business?.id || reduxAvailablePackages?.length) return;
		loadAvailablePackages(business.id, business.language);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [business?.id]);

	// Mesma regra da tela de horários: com política ativa e outro avulso de preço fixo,
	// o "Trocar" não oferece compra de pacote
	const purchaseOffersFor = (serviceId) => {
		const otherPricingTypes = standaloneServices
			.filter((service) => String(service.service_id) !== String(serviceId))
			.map((service) => service.professional?.pricingType);
		const isPolicyActiveForBusiness = !!getPolicyCancellation(business?.id)?.isPolicyCancellationActive;
		if (!canOfferPackagePurchase(isPolicyActiveForBusiness, otherPricingTypes)) return [];
		return reduxRecommendedPackages?.length ? reduxRecommendedPackages : reduxAvailablePackages;
	};

	// "Trocar" na revisão. Entre usar pacote e avulso, troca no lugar. Envolvendo
	// compra, o serviço muda de lista (services ↔ selectedPackages) e o valor a
	// pagar precisa ser recalculado do zero: atualiza o state da rota e recarrega.
	const applyPackageChoiceChange = (serviceId, choice, { fromPackageIdx = null } = {}) => {
		const state = props.location.state || {};
		let nextServices = [...(state.services || [])];
		let nextPackages = [...(state.selectedPackages || [])];
		const nextChoices = { ...(state.packageChoices || {}) };
		let needsReload = false;

		if (fromPackageIdx !== null) {
			const pkgData = nextPackages[fromPackageIdx];
			if (choice.type === "purchase" && choice.offer?.id === pkgData?.body?.package_id) return;
			nextPackages = nextPackages.filter((_, idx) => idx !== fromPackageIdx);
			if (pkgData?.checkoutService) nextServices.push(pkgData.checkoutService);
			needsReload = true;
		}

		delete nextChoices[serviceId];
		if (choice.type === "purchase") {
			const service = nextServices.find((s) => String(s.service_id) === String(serviceId));
			const packagePayload = buildPackageCheckoutPayload(choice.offer, {
				service: { id: service?.service_id },
				professional: service?.professional,
				time: { start: service?.date },
			});
			if (!service || !packagePayload) return;
			nextPackages.push({ ...packagePayload, checkoutService: service });
			nextServices = nextServices.filter((s) => s !== service);
			needsReload = true;
		} else {
			nextChoices[serviceId] = choice;
		}

		props.history.replace(props.location.pathname, {
			...state,
			services: nextServices,
			selectedPackages: nextPackages,
			infoPackage: nextPackages[nextPackages.length - 1] || null,
			packageChoices: nextChoices,
		});
		if (needsReload) {
			window.location.reload();
			return;
		}
		syncSessionsFromChoices(nextChoices);
	};

	useEffect(() => {
		if (!isSchedulingPackageSession || !bookingId || !services?.[0]) return;
		const svc = services[0];
		const duration = svc?.professional?.duration || svc?.service?.serviceDuration || 60;
		const sessionData = {
			bookingId: bookingId,
			serviceId: svc.service_id,
			payload: {
				start_time: svc.date,
				end_time: new Date(new Date(svc.date).getTime() + duration * 60000).toISOString(),
				acesso: "web",
				answer: "",
			},
			infoPackage: {
				packageName: packageSessionInfo?.packageName || svc.service?.serviceName || "",
				packageQuantity: packageSessionInfo?.packageQuantity ?? 1,
				packageRemainding: packageSessionInfo?.packageRemainding ?? 0,
				paymentStatus: "completed",
				packageTotalPrice: 0,
				servicePricePackage: svc.professional?.price || 0,
				packageExpiry: packageSessionInfo?.packageExpiry
					? formatDateDDMMYYYY(dayjs(packageSessionInfo.packageExpiry).toISOString(), i18n.language)
					: null,
			},
			services: [svc],
		};
		dispatch(checkUserPackageSessionsAction.sessionsAccepted([sessionData]));
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isSchedulingPackageSession]);

	const buildPackageModalQueue = () => {
		const byService = {};
		groupedSessions.forEach((gs) => {
			const svcId = gs.service?.id;
			if (!svcId) return;
			if (!canOfferPendingPackage(gs, isPolicyActive, effectiveServices.length)) return;
			if (!byService[svcId]) byService[svcId] = [];
			byService[svcId].push(gs);
		});
		return Object.entries(byService)
			.map(([svcId, sessions]) => {
				const numId = Number(svcId) || svcId;
				const service = effectiveServices?.find((s) => s.service_id === numId) ?? null;
				return service ? { serviceId: numId, sessions, service } : null;
			})
			.filter(Boolean);
	};

	const openPackageModalQueue = () => {
		const queue = buildPackageModalQueue();
		if (queue.length > 0) {
			clearSessionsAccepted();
			setUserDeclinedPackage(false);
			setPackageModalQueue(queue);
			setPackageModalQueueIndex(0);
			setPackageModalDeclinedCount(0);
		}
	};

	useEffect(() => {
		if (
			sessionsPackagesAvailable?.length > 0 &&
			verificationUserIsNotAnonymous &&
			!schedulingServicePackage &&
			// com o fluxo novo, o saldo já foi oferecido no passo de horários
			!packageFlow
		) {
			const timer = setTimeout(() => {
				openPackageModalQueue();
			}, 800);
			return () => clearTimeout(timer);
		}
	}, [sessionsPackagesAvailable?.length]);

	const groupedSessions = useMemo(() => {
		const map = {};
		(sessionsPackagesAvailable || []).forEach((s) => {
			const key = s.bookingTransactionId;
			if (!map[key]) {
				map[key] = {
					bookingTransactionId: key,
					package: s.package,
					professional: s.professional,
					service: s.service,
					remainingSessions: s.remainingSessions,
					createdAt: s.createdAt || null,
					paymentStatus: s.paymentStatus || null,
					sessions: [],
				};
			}
			map[key].sessions.push({ id: s.id, price: s.price, expiresAt: s.expiresAt });
		});
		return Object.values(map);
	}, [sessionsPackagesAvailable]);

	useEffect(() => {
		if (!business) return;
		const noServices = !services || services.length === 0;
		const hasPackages = hasActivatedPackage();
		const noSpecialFlow =
		  !postPayment &&
		  !reschedule &&
		  !schedulingServicePackage &&
		  !(sessionsAccepted && sessionsAccepted.length > 0) &&
		  !hasPackages;
		if (noServices && noSpecialFlow) {
		  props.history.replace(`/business/${business.id}`); 
		}
	  }, [
		business,
		services?.length,
		postPayment,
		reschedule,
		schedulingServicePackage,
		sessionsAccepted?.length,
	  ]);

	// Acesso direto à URL do checkout (sem passar pelo SelectScheduleTime):
	// chama check_slot para verificar se o slot já foi reservado por outro cliente.
	const hasCheckedSlotOnMount = useRef(false);
	useEffect(() => {
		const isPageReload = performance.getEntriesByType?.('navigation')?.[0]?.type === 'reload';
		if ((slotChecked && !isPageReload) || hasCheckedSlotOnMount.current) return;
		if (!business?.id || !services?.length) return;

		hasCheckedSlotOnMount.current = true;

		checkSlotBookingTransaction(
			services.map((service) => ({
				professional_id: service.professional_id,
				service_id: service.service_id,
				start_time: service.date,
				business_id: business.id,
			}))
		)
			.then(({ data }) => {
				const results = Array.isArray(data) ? data : [];
				const existingResult = results.find((r) => r?.exists);
				if (existingResult) {
					const bookingTransactionId =
						existingResult.bookingTransactionId || existingResult.booking_transaction_id;
					props.history.replace(
						`/confirmation/${business.id}/bookingTransactionId/${bookingTransactionId}`,
						{ fromCheckSlot: true }
					);
				}
			})
			.catch(() => {
				// Falha silenciosa — não bloqueia o checkout.
			});
	}, [business?.id, services?.length, slotChecked]);

	useEffect(() => {
		handleBreadcrumb('scheduling.checkout', 'Abriu checkout', {
			businessId: props.match?.params?.id,
			serviceCount: services?.length,
			hasCoupon: !!coupon,
			isReschedule: !!reschedule,
		});

		if (props?.location?.state?.recipientId) {
			localStorage.setItem("@prit-web/checkoutPayload", JSON.stringify({
				...props?.location?.state,
				_businessId: props.match?.params?.id,
			}));
		}

		const shouldLoad = !hasLoadedCheckoutData.current || authStatus === "SUCCESS";
		if (!shouldLoad) return;
		if (authStatus && authStatus !== "SUCCESS" && hasLoadedCheckoutData.current) return;

		if (postPayment) {
			hasLoadedCheckoutData.current = true;
			let format = {
				total_value_for_services: infoPackage?.info?.packagePrice,
				total_discounts: 0,
				anticipation_payment: infoPackage?.info?.packagePrice,
				amount: infoPackage?.info?.packagePrice,
				cancellation_policy: postPayment?.use_cancellation_policy,
			};

			setCheckoutInformationPackage(format);
			setCheckoutInformation((prev) => ({
				...prev,
				...postPayment.checkoutInformation,
			}));
		} else {
			if (services?.length > 0 && business?.id) {
				hasLoadedCheckoutData.current = true;
				setLoading(true);

				const fetchAll = async () => {
					setLoading(true);
					try {
						const contractData = await loadContract(business.id);
						setContract(contractData);
					} catch (err) {
						console.warn("Falha ao carregar contrato:", err);
					}
					loadPolicyCancellation(
						business.id,
						language || business.language
					);
					await anticipatedAmountCheckout(buildAnticipationRequest(latestAnticipationServices.current));
					setLoading(false);
				};

				fetchAll().catch((err) => {
					console.error("Erro inesperado no fetchAll:", err);
					setLoading(false);
				});
			}
		}
	}, [authStatus]);

	// useEffect para atualizar checkoutInformationPackage quando infoPackage muda
	useEffect(() => {
		if (infoPackage && infoPackage.info?.packagePrice) {
			const updateCheckoutInfo = async () => {
				try {
					setLoading(true);
					// Buscar política de cancelamento se necessário
					let cancellationPolicy = null;
					try {
						const { data } = await checkoutServices.fetchCancellationPolicyScreen(business?.id, business?.language);
						cancellationPolicy = data?.cancellation_policy ?? null;
					} catch (err) {
						console.warn("Erro ao buscar política de cancelamento:", err);
					}

					// Calcular amount total considerando serviços avulsos se houver
					let totalAmount = infoPackage.info.packagePrice;
					if (services && services.length > 0) {
						const packageServiceIds = getPackageServiceIds(infoPackage, selectedPackages);
						// serviço coberto por sessão de pacote não entra no valor
						const purchaseStandaloneServices = standaloneServices.filter((service) => !packageServiceIds.includes(service.service_id));

						if (purchaseStandaloneServices.length > 0) {
							const standaloneServicesAnticipation = await calculateStandaloneServicesAnticipation(purchaseStandaloneServices, recipientId, couponCheck, coupon);
							totalAmount += standaloneServicesAnticipation;
						}
					}

					const format = {
						total_value_for_services: infoPackage.info.packagePrice,
						total_discounts: 0,
						anticipation_payment: infoPackage.info.packagePrice,
						amount: totalAmount,
						cancellation_policy: cancellationPolicy,
					};
					setCheckoutInformationPackage(format);
					setLoading(false);
				} catch (error) {
					setLoading(false);
					console.error("Erro ao atualizar checkoutInformationPackage:", error);
				}
			};

			updateCheckoutInfo();
		}
	}, [infoPackage, business?.id, business?.language]);

	// Seta checkoutInformationPackage com valor integral do pacote quando há sessão pendente de pagamento
	useEffect(() => {
		if (!isSessionPending) return;
		const pendingInfo = sessionsAccepted?.[0]?.infoPackage;
		if (!pendingInfo?.packageTotalPrice) return;
		setCheckoutInformationPackage({
			total_value_for_services: pendingInfo.packageTotalPrice,
			anticipation_payment: pendingInfo.packageTotalPrice,
			amount: pendingInfo.packageTotalPrice,
			total_discounts: 0,
			cancellation_policy: null,
		});
	}, [isSessionPending]);

	// Recalcula checkoutInformation usando apenas serviços avulsos quando houver pacotes selecionados
	useEffect(() => {
		const shouldRecalculate = Array.isArray(selectedPackages) && selectedPackages.length > 0;
		if (!shouldRecalculate) return;

		const recalc = async () => {
			try {
				const svcList = standaloneServices;
				// Se não houver avulsos, zera antecipação
				if (svcList.length === 0) {
					setCheckoutInformation((prev) => ({
						...prev,
						anticipation_payment: 0,
						amount: 0,
					}));
					return;
				}
				const seq = ++anticipationRequestSeq.current;
				const { data } = await checkoutServices.getAnticipatedAmountCheckout(buildAnticipationRequest(svcList));
				if (seq !== anticipationRequestSeq.current) return;
				setCheckoutInformation((prev) => ({ ...prev, ...data }));
			} catch (err) {
				console.warn("Falha ao recalcular checkoutInformation para serviços avulsos:", err);
			}
		};

		recalc();
	}, [services, sessionServicesKey]);

	// Sessão de pacote aceita/trocada depois do carregamento: o valor antecipado
	// passa a considerar só os avulsos que sobraram
	const lastSessionServicesKey = useRef(sessionServicesKey);
	useEffect(() => {
		if (lastSessionServicesKey.current === sessionServicesKey) return;
		lastSessionServicesKey.current = sessionServicesKey;
		if (!hasLoadedCheckoutData.current || postPayment || selectedPackages?.length > 0 || !business?.id) return;
		const svcList = servicesForAnticipation();
		if (svcList.length === 0) return;
		anticipatedAmountCheckout(buildAnticipationRequest(svcList));
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [sessionServicesKey]);

	// Com avulsos junto de sessão de pacote, cria o booking só dos avulsos; o update
	// da sessão fica com quem chama (depois da confirmação ou do pagamento)
	const postBooking = async (is_offer_refused) => {
		if (hasOnlyPackageSessions) {
			try {
				await updateAcceptedSessions();

				redirectToStandardConfirmation();
			} catch (error) {
				console.error("Erro durante atualização das sessões no postBooking:", error);
				dialog
					.withMessage(t("generic_error_try_again"))
					.withAction(() => window.location.reload())
					.show();
				throw error;
			}
			return;
		}

		// Guard: anticipated-amount-checkout pode não ter completado (ex: falha silenciosa no
		// remount pós-login). Sem checkoutInformation, is_cancellation_policy fica undefined
		// e o JSON.stringify remove a chave — a API interpreta isso como "sem política".
		if (!checkoutInformation) {
			console.error("postBooking chamado com checkoutInformation null — abortando para evitar agendamento sem política de cancelamento");
			dialog
				.withMessage("Não foi possível calcular o valor do agendamento. Recarregue a página e tente novamente.")
				.show();
			const guardErr = new Error("checkout_not_loaded");
			guardErr.__handled__ = true;
			throw guardErr;
		}

		localStorage.removeItem("@prit-web/showLogin");
		let bookingData = {
			bookings: standaloneServices.map((item) => ({
				business_id: recipientId || business?.id,
				professional_id: item?.professional_id,
				service_id: item?.service_id,
				start_time: dayjs(item?.dateStart || item.date_start).utc().format(),
				end_time: dayjs(item?.dateStart || item.date_start).utc().add(item?.professional?.duration || item.professional.duration, "minute").format(),
				acesso: "web",
				answer: observation,
			})),
			is_cancellation_policy: checkoutInformation?.use_cancellation_policy,
			is_offer_refused: is_offer_refused ? true : false,
		};

		if (couponCheck) {
			bookingData.coupon_id = coupon?.coupon?.coupon_id;
		}

		const localRwgToken = localStorage.getItem("@prit-web/rwg_token");

		if (localRwgToken && !_.isNull(localRwgToken) && !_.isEmpty(localRwgToken)) {
			bookingData.bookings.forEach((booking) => {
				booking.rwg_token = localRwgToken;
			});
		}

		let emptyFields = [];
		let invalidTimeFields = [];

		bookingData.bookings.forEach((booking, index) => {
			Object.entries(booking).forEach(([key, value]) => {
				if (key !== "answer" && (value === undefined || value === "" || value === null)) {
					emptyFields.push(`Booking ${index + 1}: ${key}`);
				}
			});

			if (dayjs(booking.end_time).isBefore(booking.start_time)) {
				invalidTimeFields.push(`Booking ${index + 1}: end_time deve ser maior que start_time`);
			}
		});

		if (emptyFields.length > 0 || invalidTimeFields.length > 0) {
			let errorMessage = "";

			if (emptyFields.length > 0) {
				errorMessage += `Os seguintes campos estão vazios ou indefinidos:\n- ${emptyFields.join("\n- ")}\n`;
			}

			if (invalidTimeFields.length > 0) {
				errorMessage += `\nErros de tempo:\n- ${invalidTimeFields.join("\n- ")}`;
			}

			alert(errorMessage);
			return;
		}

		try {
			const result = await bookingTransactionService.postBookingTransaction(bookingData);
			return result;
		} catch (error) {
			const errorConfig = getApiErrorConfig(error);
			const handled = showApiError(error, null, {
				primaryButton: {
					labelKey: "understood",
					onClick: () => props.history.push(`/business/${business?.id}`),
				},
				...(!errorConfig?.suppressSecondaryButton && {
					secondaryButton: {
						labelKey: "View reservations",
						onClick: () => props.history.push("/reservas"),
					},
				}),
			}, { services, valor_agendamento: checkoutInformation?.total_value_for_services });
			if (handled) error.__handled__ = true;
			throw error;
		}
	};

	const redirectToStandardConfirmation = () => {
		props.history.push(`/confirmation/${business?.id}`, {
			checkout: checkoutInformation,
			checkoutInformationPackage: checkoutInformationPackage,
			singleServices: effectiveServices,
			selectedPackages: selectedPackages,
			infoPackage: infoPackage,
			business: business,
			payload: props?.location?.state?.recipientId ? props.location.state : payload,
			couponValue: coupon,
			totalPricingType: totalPricingType,
		});
	};

	// Extrai a hora de início da mensagem "Profissional não tem uma agenda de DD/MM/YYYY - HH:mm …"
	// e devolve o índice do serviço em effectiveServices cujo horário bate com o da mensagem.
	// Fallback: índice 0.
	const findNoAgendaServiceIndex = (message) => {
		const match = message?.match(/(\d{2}\/\d{2}\/\d{4})\s*-\s*(\d{2}:\d{2})/);
		if (!match) return 0;
		const [, datePart, timePart] = match;
		const [day, month, year] = datePart.split("/");
		const messageDateTime = `${day}/${month}/${year} ${timePart}`;
		const tz = businessRef.current?.timeZone;
		const idx = effectiveServices.findIndex((svc) => {
			const formatted = dayjs(svc.dateStart || svc.date)
				.utc()
				.tz(tz)
				.format("DD/MM/YYYY HH:mm");
			return formatted === messageDateTime;
		});
		return idx >= 0 ? idx : 0;
	};

	const markServiceAsExpired = async (originalIndex, errorMessage = null) => {
		const service = effectiveServices[originalIndex];
		if (!service) return;

		setServiceRecoveryState((prev) => ({
			...prev,
			[originalIndex]: {
				status: "expired",
				loadingSlots: true,
				alternativeSlots: [],
				hasFeatureItems: true,
				expandedAllSlots: false,
				errorMessage,
			},
		}));

		const { slots, hasFeatureItems } = await fetchAlternativeSlotsForService({
			business: businessRef.current,
			expiredService: service,
			language,
		});

		setServiceRecoveryState((prev) => ({
			...prev,
			[originalIndex]: {
				...prev[originalIndex],
				status: "expired",
				loadingSlots: false,
				alternativeSlots: slots,
				hasFeatureItems,
			},
		}));
	};

	const { handleBookingError } = useCheckoutBookingErrorHandler({
		effectiveServices,
		markServiceAsExpired,
		findNoAgendaServiceIndex,
		eventProps,
		currentUser,
		business,
		services,
		valorAgendamento: checkoutInformation?.total_value_for_services,
		showApiError,
	});

	const handleSelectAlternativeSlot = (originalIndex, slot) => {
		mixpanelTrackEvent(
			"Horario_Alternativo_Selecionado",
			{ horario_selecionado: slot.start },
			currentUser,
			business
		);
		setServiceRecoveryState((prev) => ({
			...prev,
			[originalIndex]: {
				status: "updated",
				newDate: slot.start,
				newProfessionalId: slot.professionalId || null,
			},
		}));
	};

	const handleSeeOtherDay = (originalIndex) => {
		const service = effectiveServices[originalIndex];
		const featureItems = service?.service?.featureItems;
		if (!business?.id) return;

		props.history.push(`/selecionar-data/${business.id}`, {
			services: featureItems
				? [
						{
							id: service.service_id,
							serviceName: service.service?.serviceName,
							featureItems,
						},
					]
				: undefined,
			bookingId,
			reschedule,
		});
	};

	const handleSeeAllThisDay = (originalIndex) => {
		const service = effectiveServices[originalIndex];
		const featureItems = service?.service?.featureItems;
		if (!featureItems || !business?.id) return;

		props.history.push(`/selecionar-horarios/${business.id}`, {
			services: [
				{
					id: service.service_id,
					serviceName: service.service?.serviceName,
					featureItems,
				},
			],
			date: service.dateStart || service.date,
			bookingId,
			reschedule,
		});
	};

	const pay = (bookingTransactionId, recipient_id) => {
		const meData = JSON.parse(localStorage.getItem("@prit-web/meData"));
		businessService
			.getBusiness(business.id)
			.then(async (res) => {
				const businessUpdated = res.data;
				const postalCode = businessUpdated?.address?.postalCode?.trim();
				if (businessUpdated.phone.startsWith("+55") && postalCode && !/^\d{8}$/.test(postalCode.replace("-", ""))) {
					setErrorMessage(t("adress problems"));
					setShowError(true);
					setLoading(false);
					return;
				}
				const address = businessUpdated.address || business.adress;
				const paypamentPay = {
					booking_external_id: bookingTransactionId,
					recipient_id: recipient_id,
					card: cardData && {
						card_holder_name: cardData.name,
						card_expiration_date: cardData.expiry,
						card_number: cardData.number,
						card_cvv: cardData.cvc,
					},
					client: {
						id: user?.id || me?.id || localStorage.getItem("@prit-web/userId") || meData?.id,
						name:
							me?.name ||
							user?.displayName ||
							cardData?.name ||
							Utils.safeLocalGet("@prit-web/userName") ||
							meData?.name ||
							"Usuário Prit",
						email: user?.email || cardData?.email || me?.email || meData?.email || "contato@prit.app",
						country: "br",
						documents: [cardData ? cardData.cpf : pix],
						phone_numbers: me?.phone ? [me.phone] : meData?.phone ? [meData?.phone] : [meData?.phoneUnverified],
						address: {
							street: address?.street || "Av. Prof. João Fiúsa",
							complementary: address?.unit || "",
							street_number: address?.number || "1901",
							neighborhood: address?.neighborhood || "Jardim Botânico",
							city: address?.city || "Ribeirão Preto",
							state: address?.state || "SP",
							zipcode: address?.postalCode || "14024250",
							country: "br",
						},
					},
					amount: checkoutInformationPackage?.amount / 100,
					discount: checkoutInformationPackage?.total_discounts / 100,
					payment_type: pix ? 5 : null,
				};
				if (coupon) {
					paypamentPay.coupon_id = coupon.coupon_id;
				}
				if (currency !== "BRL") {
					const res = await payPaymentService.postPayIntent(paypamentPay);
				} else {
					bookingTransactionService.publishBooktranscation(bookingTransactionId);

					const paymentTimeout = setTimeout(() => {
						setShowPaymentProcessingModal(true);
					}, 2000);

					payPaymentService
						.postPaymentPay(paypamentPay)
						.then((paymentPayRequest) => {
							clearTimeout(paymentTimeout);
							setShowPaymentProcessingModal(false);

							if (pix) {
								pixIntervalRef.current = setInterval(() => {
									getOneBookingTransaction(bookingTransactionId).then((res) => {
										let status = res.data.paymentStatus;
										if (status !== "pending") {
											clearInterval(pixIntervalRef.current);
											pixIntervalRef.current = null;
											if (status === "partial" || status === "completed") {
												dialog.updateProps({ isVerifying: true });
												setTimeout(() => {
													const totalCents = checkoutInformationPackage?.anticipation_payment || checkoutInformation?.anticipation_payment || totalValuePrices || 0;
													const formatted = (totalCents / 100).toLocaleString("pt-BR", { style: "currency", currency: currency || "BRL" });
													dialog.updateProps({ isVerifying: false, isConfirmed: true, paymentValue: formatted });
												}, 1500);
											}
										}
									});
								}, 5000);
								setPixCode(paymentPayRequest.data.pix_qr_code);
								setLoading(false);
							} else {
								const currentUser = me || user || {};
								const typeLogin = localStorage.getItem("@prit-web/TypeLogin");
								mixpanelTrackEvent(
									"Novo_Agendamento",
									{
										Forma_De_Agendamento: "Web_Consumidor",
										Meio_De_Pagamento: "Nenhum",
										Servicos: serviceNamesSelected,
										Tipo_De_Login: typeLogin || null,
										Origem_De_Agendamento: getBookingOrigin(),
										Valor: totalValuePrices,
										Moeda: currency,
										tipo_atendimento: TIPO_ATENDIMENTO.SESSAO_DE_PACOTE,
									},
									currentUser || {},
									business,
									true
								);
								let isOwnerUser =
									!_.isEmpty(currentUser?.id) && !_.isEmpty(business?.ownerId) && currentUser.id === business.ownerId;
								mixpanelTrackEvent("Agendamento_Confirmado", currentUser, isOwnerUser ? business : {});
								setLoading(false);
								redirectToStandardConfirmation();
							}
						})
						.catch((err) => {
							clearTimeout(paymentTimeout);
							setShowPaymentProcessingModal(false);
							bookingTransactionService.putBookingTransaction(bookingTransactionId);
							let message = err?.response?.data?.message || err?.message;
							if (message && message.includes && message.includes("email")) {
								setErrorMessage("O email informado é inválido, por favor, verifique e tente novamente");
							} else {
								setErrorMessage(message || "Verifique sua conexão e tente novamente");
							}
							setShowError(true);
							setLoading(false);
						});
				}
			})
			.catch((err) => {
				let message = err?.response?.data?.message || err?.message;
				if (message && message.includes && message.includes("email")) {
					setErrorMessage("O email informado é inválido, por favor, verifique e tente novamente");
				} else {
					setErrorMessage(message || "Verifique sua conexão e tente novamente");
				}
				setShowError(true);
				setLoading(false);
			});
	};

	const activePackageAndSchedule = async (redirect = false) => {
		const typeLogin = Utils.safeLocalGet("@prit-web/TypeLogin");
		try {
			if (sessionsAccepted && sessionsAccepted.length > 0) {
				try {
					const updatePromises = sessionsAccepted.map((session) => 
						updateScheduleSession(session).catch((error) => {
							console.error("Erro ao atualizar sessão:", session, error);
							throw error;
						})
					);

					await Promise.allSettled(updatePromises);
				} catch (error) {
					console.error("Erro durante atualização das sessões no activePackageAndSchedule:", error);
					dialog
						.withMessage(t("generic_error_try_again"))
						.withAction(() => window.location.reload())
						.show();
					throw error;
				}
			}

			if (!selectedPackages && selectedPackages.length === 0) return;

			const activatingPackages = async (packageData, isFirstPackage = false) => {
				if (isPackageActivating || isProcessing) {
					return;
				}

				setIsPackageActivating(true);
				const bodyWithRoundedPrices = roundPricesDown(packageData.body, packageData.info?.packagePrice);

				const packagePrice = packageData.info?.packagePrice || 0;
				const totalAmount = packagePrice;

				if (bodyWithRoundedPrices.amount !== undefined) {
					bodyWithRoundedPrices.amount = totalAmount;
				}

				// serviço coberto por sessão de pacote vira update da sessão, não booking
				if (isFirstPackage && standaloneServices.length > 0) {
					const standaloneServicesBookings = standaloneServices.map((service) => ({
						business_id: recipientId || business?.id,
						professional_id: service.professional_id,
						service_id: service.service_id,
						start_time: dayjs(service.dateStart).utc().format(),
						end_time: dayjs(service.dateStart).utc().add(service.professional.duration, "minute").format(),
						acesso: "web",
						answer: observation,
					}));

					if (bodyWithRoundedPrices.bookings && bodyWithRoundedPrices.bookings.length > 0) {
						bodyWithRoundedPrices.bookings = [...bodyWithRoundedPrices.bookings, ...standaloneServicesBookings];
					}
				}

				if (packageData?.accepted_offer) {
					const serviceDateTime = packageData?.serviceDateTime || {};
					const start_time = serviceDateTime?.start_time;
					const end_time = serviceDateTime?.end_time;
					if (
						start_time &&
						end_time &&
						Array.isArray(bodyWithRoundedPrices?.bookings) &&
						bodyWithRoundedPrices.bookings.length > 0
					) {
						bodyWithRoundedPrices.bookings[0] = {
							...bodyWithRoundedPrices.bookings[0],
							start_time,
							end_time,
							acesso: "web",
							answer: "",
						};
					}
				}

				try {
					const res = await bookingTransactionService.postBookingTransaction(bodyWithRoundedPrices);
					
					const bookingTransactionId = res?.data?.bookings?.[0]?.bookingTransactionId;

					if (
						bookingTransactionId && activePaymentPackage(checkoutInformationPackage, offerAccepted)
					) {
						pay(bookingTransactionId, business.id);
					}

					if (redirect) {
						redirectToStandardConfirmation();
					}

					return {
						bookingTransactionId: bookingTransactionId,
					};
				} catch (error) {
					console.error("Falha ao ativar pacote e agendar:", error);
				} finally {
					setIsPackageActivating(false);
				}
			};

			for (let i = 0; i < selectedPackages.length; i++) {
				const packageData = selectedPackages[i];
				const isFirstPackage = i === 0;
				mixpanelTrackEvent(
					"Ativacao_pacote",
					{
						Origem: "Checkout",
						Pacote: packageData?.info?.packageName,
						Servico_Nome: packageData?.info?.serviceName,
						Valor_Pacote:Utils.getPostPrice(packageData?.info?.packagePrice, business?.currency) || "0",
						Telefone_Cliente: currentUser?.phone,
						Tipo_De_Login: typeLogin || null
					},
					currentUser,
					business
				);
				await activatingPackages(packageData, isFirstPackage);
			}
		} catch (error) {
			console.error("Falha ao ativar pacote e agendar:", error);
		} finally {
			setIsPackageActivating(false);
		}
	};

	const hasActivatedPackage = () => {
		return !!infoPackage || (selectedPackages && selectedPackages.length > 0);
	};

	const runCheckSlot = async (servicesToCheck) => {
		if (!servicesToCheck?.length) return { exists: false };
		try {
			const { data } = await checkSlotBookingTransaction(
				servicesToCheck.map((service) => ({
					professional_id: service.professional_id,
					service_id: service.service_id,
					start_time: service.date,
					business_id: business.id,
				}))
			);
			const results = Array.isArray(data) ? data : [];
			const existingResult = results.find((r) => r?.exists);
			if (existingResult) {
				return {
					exists: true,
					bookingTransactionId:
						existingResult.bookingTransactionId || existingResult.booking_transaction_id,
				};
			}
			return { exists: false };
		} catch {
			// Fail silently — não bloqueia o agendamento.
			return { exists: false };
		}
	};

	const handleScheduleClickConfirm = async (is_offer_refused) => {
		if (isProcessing) return;
		// Se há pacote ativo, ativa e agenda imediatamente
		if (hasActivatedPackage()) {
			setIsProcessing(true);
			setLoading(true);
			await activePackageAndSchedule(true);
			setLoading(false);
			setIsProcessing(false);
			return;
		}

		// Só sessões de pacote: basta o update das sessões
		if (hasOnlyPackageSessions) {
			try {
				setIsProcessing(true);
				setLoading(true);

				await updateAcceptedSessions();

				setLoading(false);
				setIsProcessing(false);
				redirectToStandardConfirmation();
				
			} catch (error) {
				console.error("Erro durante atualização das sessões:", error);
				setLoading(false);
				setIsProcessing(false);
				dialog
					.withMessage(t("generic_error_try_again"))
					.withAction(() => window.location.reload())
					.show();
				return;
			}
			return;
		}

		setIsProcessing(true);
		setLoading(true);
		if (reschedule) {
			bookingTransactionService
				.putBookingUpdateSchedule({
					bookingId: reschedule.bookingId,
					data: {
						business_id: reschedule.businessId,
						professional_id: reschedule.professionalId,
						service_id: reschedule.serviceId,
						start_time: new Date(new Date(effectiveServices[0]?.date).getTime()).toISOString(),
						end_time: new Date(
							new Date(effectiveServices[0]?.date).getTime() + effectiveServices[0]?.service?.serviceDuration * 60000
						).toISOString(),
						acesso: "web",
						answer: observation,
					},
				})
				.then((res) => {
					props.history.push(`/confirmation/${business?.id}`, {
						checkout: checkoutInformation,
						selectedPackages: selectedPackages,
						infoPackage: infoPackage,
						business: business,
						payload: recipientId ? props.location.state : payload,
						singleServices: effectiveServices,
						couponValue: coupon,
						totalPricingType: totalPricingType,
						offerAccepted: offerAccepted,
					});
					setLoading(false);
				})
				.catch((err) => {
					const message = err?.response?.data?.message || err?.message || err;
					if (isAdvanceNoticeError(err)) {
						markServiceAsExpired(0);
					} else if (!showApiError(err, null, null, { services, valor_agendamento: checkoutInformation?.total_value_for_services })) {
						dialog.withMessage(`${message}, Tente novamente!`).show();
					}
					setLoading(false);
				})
				.finally(() => {
					setTimeout(() => {
						setIsProcessing(false);
					}, 1000);
				});
		} else if (schedulingServicePackage) {
			bookingTransactionService
				.putBookingUpdateSchedule({
					bookingId: bookingId,
					data: {
						start_time: new Date(new Date(effectiveServices[0]?.date).getTime()).toISOString(),
						end_time: new Date(
							new Date(effectiveServices[0]?.date).getTime() + effectiveServices[0]?.service?.serviceDuration * 60000
						).toISOString(),
						acesso: "web",
						answer: observation,
					},
				})
				.then((res) => {
					props.history.push(`/confirmation/${business?.id}`, {
						checkout: checkoutInformation,
						selectedPackages: selectedPackages,
						infoPackage: infoPackage,
						business: business,
						payload: recipientId ? props.location.state : payload,
						singleServices: effectiveServices,
						couponValue: coupon,
						totalPricingType: totalPricingType,
						offerAccepted: offerAccepted,
					});
					setLoading(false);
				})
				.catch((err) => {
					const message = err?.response?.data?.message || err?.message || err;
					if (isAdvanceNoticeError(err)) {
						markServiceAsExpired(0);
					} else if (!showApiError(err, null, null, { services, valor_agendamento: checkoutInformation?.total_value_for_services })) {
						dialog.withMessage(`${message}, Tente novamente!`).show();
					}
					setLoading(false);
				})
				.finally(() => {
					setTimeout(() => {
						setIsProcessing(false);
					}, 1000);
				});
		} else {
			if (isOwnerUser) {
				mixpanelTrackEvent("Confirmar_Agendamento", eventProps, currentUser, business);
			}

			const slotCheck = await runCheckSlot(standaloneServices);
			if (slotCheck.exists) {
				props.history.replace(
					`/confirmation/${business.id}/bookingTransactionId/${slotCheck.bookingTransactionId}`,
					{ fromCheckSlot: true }
				);
				setLoading(false);
				setIsProcessing(false);
				return;
			}

			// Avulsos já agendados: falta usar a sessão do pacote. Se falhar, tenta de novo
			// só o update (recarregar cairia no check_slot e a sessão ficaria sem uso)
			const applyAcceptedSessions = async () => {
				if (!(sessionsAccepted?.length > 0)) return;
				try {
					await updateAcceptedSessions();
				} catch (error) {
					console.error("Erro ao atualizar as sessões depois do agendamento dos avulsos:", error);
					await new Promise((resolve) => {
						dialog
							.withMessage(t("generic_error_try_again"))
							.withAction(() => applyAcceptedSessions().then(resolve))
							.show();
					});
				}
			};

			const typeLogin = Utils.safeLocalGet("@prit-web/TypeLogin");
			postBooking(is_offer_refused)
				.then(async (res) => {
					await applyAcceptedSessions();
					setLoading(false);
					// Reserva 'waiting' ainda aguarda o pagamento antecipado: o Novo_Agendamento
					// (Mixpanel + engagement, que manda o "seu horário está agendado") só sai
					// quando o pagamento for confirmado.
					const isWaitingPayment = res?.data?.bookings?.some((booking) => booking?.status === "waiting");
					if (!isWaitingPayment) {
						mixpanelTrackEvent(
							"Novo_Agendamento",
							{
								Forma_De_Agendamento: "Web_Consumidor",
								Meio_De_Pagamento: "Nenhum",
								Tipo_De_Login: typeLogin || null,
								Origem_De_Agendamento: getBookingOrigin(),
								Servicos: serviceNamesSelected,
								Valor: totalValuePrices,
								Moeda: currency,
								tipo_atendimento: TIPO_ATENDIMENTO.INDIVIDUAL,
							},
							currentUser,
							business,
							true
						);
					}
					localStorage.removeItem("@prit-web/checkoutPayload");
					props.history.push(`/confirmation/${business?.id}`, {
						checkout: checkoutInformation,
						selectedPackages: selectedPackages,
						infoPackage: infoPackage,
						business: business,
						payload: recipientId ? props.location.state : payload,
						singleServices: effectiveServices,
						couponValue: coupon,
						totalPricingType: totalPricingType,
						offerAccepted: offerAccepted,
					});
					if (!isWaitingPayment) {
						mixpanelTrackEvent("Agendamento_Confirmado", {}, currentUser, isOwnerUser ? business : {});
					}
				})
				.catch((err) => {
					const message = err?.response?.data?.message;
					setLoading(false);
					if (!handleBookingError(err, message)) {
						dialog.withMessage(`${message} Tente novamente!`).show();
					}
				})
				.finally(() => {
					setTimeout(() => {
						setIsProcessing(false);
					}, 1000);
				});
		}
	};

	/**
	 * Valida o telefone do usuário e exibe modal de correção se necessário.
	 * Verifica se o telefone registrado após login com o Google é válido ou está nulo.
	 * @param {string} [tipoPagamento=""] - Tipo de pagamento para rastreamento (ex: "Pix", "Cartão").
	 * @returns {boolean} `true` se telefone precisa correção (interrompe execução), `false` se válido.
	 */ 
	const validateAndHandlePhone = (tipoPagamento) => {
		if (!me?.phone && me?.phoneUnverified && (userIdStorage || me?.id || meStore?.id)) {
			const validatePhone = Utils.validatePhone(me?.phoneUnverified);
			if (validatePhone.needsUpdate) {
				mixpanelTrackEvent(
					"Telefone_Invalido_Google",
					{
						phone: me?.phoneUnverified,
						businessId: business.id,
						userId: me?.id,
						tipoPagamento: tipoPagamento || "",
					},
					currentUser,
					business
				);
				setPhoneModalConfig({
					titleKey: "Fix your phone",
					messageKey: "Google phone invalid message",
				});
				return true; 
			}
		}
	
		if (!me?.phoneUnverified && !me?.phone && (userIdStorage || me?.id || meStore?.id)) {
			mixpanelTrackEvent(
				"Telefone_Nulo_Google",
				{
					userId: me?.id,
					tipoPagamento: tipoPagamento || "",
				},
				currentUser,
				business
			);
			setPhoneModalConfig({
				titleKey: "Complete your phone",
				messageKey: "You logged in with Google We need your number to send confirmations via WhatsApp",
			});
			return true;
		}
	
		return false; 
	};

	const handleObservation = (event) => {
		let text = event.target.value;
		if (text.length <= 300) {
			setObservation(text);
			setCharacterCount(text.length);
		}
	};

	useEffect(() => {
		// Proteção contra execuções desnecessárias
		if (isProcessing || loading || isPackageActivating) {
			return;
		}
		if (cardData || pix) {
			dialog
				.withContent(DialogPayConfirm)
				.withProps({
					postPayment,
					cardData,
					pix,
					checkoutInformation,
					totalPricingType,
					currency,
					coupon,
					payload: recipientId ? props.location.state : payload,
					postBooking,
					setPixCode,
					onPixConfirmed: handlePixConfirmedFromPayConfirm,
					onPixUnblock: unblockPixNavigation,
					showUpdateInfo: () => setShowUpdateInfo(!showUpdateInfo),
					showError: (msg) => {
						setErrorMessage(msg);
						setShowError(true);
					},
					offerAccepted,
					laterPayment,
					eventProps,
					handleBookingError,
					onPaymentConfirmed: sessionsAccepted?.length > 0 ? updateAcceptedSessions : undefined,
				})
				.show();
		}

		if (cardData || pix) {
			const isPendingSessionOnly = isSessionPending && !hasActivatedPackage();
			if (hasActivatedPackage() || isPendingSessionOnly) {
				const pendingSessionPostBooking = isPendingSessionOnly
					? () =>
							updateScheduleSession(sessionsAccepted[0]).then(() => ({
								data: {
									bookings: [{ bookingTransactionId: sessionsAccepted[0]?.bookingId }],
								},
							}))
					: activePackageAndSchedule;
				dialog
					.withContent(dialogPayConfirmPackage)
					.withProps({
						cardData,
						pix,
						checkoutInformation: checkoutInformationPackage,
						checkoutInformationServices: checkoutInformation,
						currency,
						payload: business?.id,
						postBooking: pendingSessionPostBooking,
						setPixCode,
						onPixUnblock: unblockPixNavigation,
						infoPackage,
						business,
						showUpdateInfo: () => setShowUpdateInfo(!showUpdateInfo),
						showError: (msg) => {
							setErrorMessage(msg);
							setShowError(true);
						},
						hasActivatedPackage: isPendingSessionOnly ? false : hasActivatedPackage(),
						services,
						selectedPackages,
					})
					.show();
			} else {
				dialog
					.withContent(DialogPayConfirm)
					.withProps({
						postPayment,
						cardData,
						pix,
						checkoutInformation,
						totalPricingType,
						currency,
						coupon,
						payload: props?.location?.state?.recipientId ? props.location.state : payload,
						postBooking,
						setPixCode,
						onPixConfirmed: handlePixConfirmedFromPayConfirm,
						onPixUnblock: unblockPixNavigation,
						showUpdateInfo: () => setShowUpdateInfo(!showUpdateInfo),
						showError: (msg) => {
							setErrorMessage(msg);
							setShowError(true);
						},
						laterPayment,
						handleBookingError,
						onPaymentConfirmed: sessionsAccepted?.length > 0 ? updateAcceptedSessions : undefined,
					})
					.show();
			}
		}
	}, [cardData, pix, isProcessing, loading, isPackageActivating]);

	const unblockPixNavigation = () => {
		if (pixUnblockRef.current) {
			pixUnblockRef.current();
			pixUnblockRef.current = null;
		}
		clearInterval(pixIntervalRef.current);
		pixIntervalRef.current = null;
	};

	// Chamado pelo poll do dialogPayConfirm quando PIX é confirmado
	// Em vez de redirecionar, atualiza o modal para exibir o fluxo visual
	const handlePixConfirmedFromPayConfirm = () => {
		dialog.updateProps({ isVerifying: true });
		setTimeout(() => {
			const totalCents = checkoutInformationPackage?.anticipation_payment || checkoutInformation?.anticipation_payment || checkoutInformation?.total_value_for_services || totalValuePrices || 0;
			const formatted = (totalCents / 100).toLocaleString("pt-BR", { style: "currency", currency: currency || "BRL" });
			dialog.updateProps({ isVerifying: false, isConfirmed: true, paymentValue: formatted });
		}, 3000);
	};

	const handlePixViewBooking = () => {
		unblockPixNavigation();
		dialog.close();
		redirectToStandardConfirmation();
	};

	const handlePixGiveUp = () => {
		clearInterval(pixIntervalRef.current);
		pixIntervalRef.current = null;
		if (pixUnblockRef.current) {
			pixUnblockRef.current();
			pixUnblockRef.current = null;
		}
		setPixCode(undefined);
	};

	useEffect(() => {
		if (!pixCode) return;

		// Block navigation while the Pix QR code is being displayed.
		// The user must click "Desistir" to leave.
		pixUnblockRef.current = props.history.block(() => false);

		dialog
			.withContent(dialogPayCod)
			.withProps({
				pixCode,
				businessId: business.id,
				onGiveUp: handlePixGiveUp,
				onViewBooking: handlePixViewBooking,
			})
			.show();

	}, [pixCode]);

	useEffect(() => {
		if (showUpdateInfo) {
			if (pix) {
				dialog.withContent(DialogPix).withProps({ setPix }).show();
			} else {
				dialog
					.withContent(DialogAddCard)
					.withProps({
						setCardData,
					})
					.show();
			}
			setShowUpdateInfo(false);
		}
	}, [showUpdateInfo]);

	useEffect(() => {
		if (showError) {
			if (isAppointmentLimitError(errorMessage)) {
				dialog.withMessage(errorMessage).show();
			} else if (isProfessionalWithNoAgendaError(errorMessage)) {
				markServiceAsExpired(findNoAgendaServiceIndex(errorMessage), t("professionalNoAgendaCardTitle"));
			} else if (!showApiError({ message: errorMessage }, null, null, { services })) {
				dialog.withMessage(errorMessage).show();
			}
			setShowError(false);
		}
	}, [showError, errorMessage]);

	useEffect(() => {
		if (
			me?.name &&
			user &&
			!user.isAnonymous &&
			!loading &&
			!isProcessing &&
			checkoutInformation &&
			!schedulingServicePackage &&
			!postPayment &&
			!reschedule &&
			!checkoutInformation?.use_cancellation_policy &&
			questions?.length === 0 &&
			isFirstLoginAfterRedirect
		) {
			const timer = setTimeout(() => {
				localStorage.removeItem("@prit-web/checkoutAutoSchedule");
				localStorage.removeItem("goBackRoute");
				handleScheduleClickConfirm();
				setIsFirstLoginAfterRedirect(false);
			}, 0);
			
			return () => clearTimeout(timer);
		}
	}, [
		me?.name,
		user,
		loading,
		isProcessing,
		checkoutInformation,
		schedulingServicePackage,
		postPayment,
		reschedule,
		questions,
		isFirstLoginAfterRedirect,
	]);

	useEffect(() => {
		if (business) {
			if (language === "portuguese" || language === "portugal") {
				i18n.changeLanguage("pt-BR");
			} else if (language === "spanish") {
				i18n.changeLanguage("es-ES");
			} else {
				i18n.changeLanguage("en-US");
			}
		}
	}, [business, i18n]);

	// Exibe modal de nome quando o usuário autenticou via WhatsApp sem nome cadastrado
	useEffect(() => {
		if (openModalCustom === "REGISTER_NAME_USER" && _.isEmpty(me?.name)) {
			setShowUserNameModal(true);
		}
	}, [openModalCustom]);

	// Detecta quando o usuário acabou de se autenticar via WhatsApp
	useEffect(() => {
		if (
			me?.name && 
			user && 
			!user.isAnonymous && 
			!loading &&
			checkoutInformation
		) {
			const hasJustAuthenticated = localStorage.getItem("@prit-web/justAuthenticated");
			if (hasJustAuthenticated === "true") {
				setTimeout(() => {
					localStorage.removeItem("@prit-web/justAuthenticated");
				}, 300);
			}

			if (me?.name && user && !user.isAnonymous && (!selectedPackages || !sessionsAccepted)) {
				let request = {
					recipient_id: recipientId,
					services: services.map((service) => ({
						date: dayjs(service.date).utc().format(),
						service_id: service.service_id,
						professional_id: service.professional_id,
						professional: {
							price:
								service.service.servicePrice > service.professional.price
									? service.service.servicePrice
									: service.professional.price,
							pricing_type: service.professional.pricingType,
						}, })),
				};
				loadContract(business.id);
						loadPolicyCancellation(
							business.id,
							language || business.language
						);
				anticipatedAmountCheckout(request);
			}
		}
	}, [me?.name, user, loading]);

	// Revisão com pacote (compra ou uso de saldo) mostra a própria política, abaixo dos valores
	const hasPackageReview =
		selectedPackages?.length > 0 || Object.values(packageChoices).some((c) => c?.type === "client");
	// usePolicyActive() lê a chave sem o id do negócio, que nunca é gravada: a política
	// da revisão com pacote vem do negócio do agendamento (mesma regra do "Trocar")
	const isBusinessPolicyActive = !!getPolicyCancellation(business?.id)?.isPolicyCancellationActive;
	// Com pacote não há valor a reembolsar: o cancelamento fora do prazo consome um atendimento
	const cancellationHours =
		checkoutInformation?.hours_before_booking_expiration ?? checkoutInformationPackage?.hours_before_booking_expiration;
	const packageCancellationMessage =
		cancellationHours > 0
			? t("checkout_session_cancellation_hours", {
					hours: cancellationHours,
					unit: cancellationHours > 1 ? t("hours") : t("hour"),
			  })
			: t("checkout_session_cancellation_message");

	// Card "Você tem pacote para…" quando a cliente recusou o próprio pacote: pela fila
	// antiga do checkout ou, no fluxo novo, com "Não usar o pacote" no passo de horários
	const declinedPackageCard = (() => {
		if (userDeclinedPackage) {
			const acceptedIds = new Set((sessionsAccepted || []).map((s) => s.serviceId));
			const declined = groupedSessions.find((gs) => gs.service?.id && !acceptedIds.has(gs.service?.id));
			if (!declined) return null;
			return {
				serviceName: declined.service?.name || effectiveServices?.[0]?.service?.serviceName || "",
				onUse: () => {
					setUserDeclinedPackage(false);
					openPackageModalQueue();
				},
			};
		}
		const declinedService = effectiveServices.find(
			(service) =>
				packageChoices[service.service_id]?.type === "avulso" &&
				getEligibleClientPackages(rawClientPackages, service.service_id, service.professional_id, service.date).length > 0
		);
		if (!declinedService) return null;
		return {
			serviceName: declinedService.service?.serviceName || "",
			onUse: () => setTrocarServiceId(declinedService.service_id),
		};
	})();

	const footer = () => {
		
		return (
			<>
				{!me?.name ? (
					<></>
				) : (
					<div>
						{!schedulingServicePackage &&
							checkoutInformation?.use_cancellation_policy &&
							(checkoutInformation?.anticipation_payment > 0 ||
								checkoutInformation?.used_percentage_value ||
								checkoutInformation?.used_fixed_value) &&
							user &&
							!user.isAnonymous &&
							!hasPackageReview && (
								<Fragment>
									<Typography className={classes.policyWrapper}>
										{checkoutInformation?.value_cancellation_fee ? `${t("Cancellation policy")}:` : ""}
									</Typography>
									<Typography className={classes.policyWrapper} style={{ padding: "0 16px", fontWeight: 400, fontSize: 12, color: "#5f5f5f" }}>
										{sessionsAccepted?.length > 0
											? packageCancellationMessage
											: Utils.policyDetails(checkoutInformation, currency, t)}
									</Typography>
								</Fragment>
							)}
					</div>
				)}
				<div style={{ padding: "12px" }}>
					{(getPolicyCancellation(business?.id)?.isPolicyCancellationActive && checkoutInformation === null && !sessionsAccepted) ? (
						<div></div>
					) : user &&
					  !user.isAnonymous &&
					  me?.name &&
					  !schedulingServicePackage &&  
					  !(hasOnlyPackageSessions && !isSessionPending) &&
					  (postPayment || isSessionPending ||
							(checkoutInformation?.use_cancellation_policy &&
								((checkoutInformation?.anticipation_payment > 0 &&
									!checkoutInformation?.anticipation_payment_percentage &&
									!reschedule) ||
									(checkoutInformation?.anticipation_payment_percentage && offerAccepted)))
								|| (activePaymentPackage(checkoutInformationPackage))
								) ? (
						<div style={{ textAlign: "end" }}>
							{business?.currency !== "BRL" ? (
								<Grid>
									{!_.isNil(contract) && !_.isEmpty(contract) && !_.isNull(contract?.transaction_percentage) && (
										<Button
											onClick={() => {
												if (questions?.length > 0 && user && !user.isAnonymous && observation === "") {
													setErrorObservation(true);
													if (observationTextField && observationTextField.current) {
														observationTextField.current.focus();
													}
												} else {
													if (isOwnerUser) {
														const eventStripeProps = {
															...eventProps,
															Meio_De_Pagamento: "Stripe",
														};
														mixpanelTrackEvent("Definiu_Meio_De_Pagamento", eventStripeProps, currentUser, business);
													}
													dialog
														.withContent(DialogPayConfirm)
														.withProps({
															postPayment,
															cardData,
															pix,
															checkoutInformation,
															totalPricingType,
															currency,
															coupon,
															payload: recipientId ? props.location.state : payload,
															postBooking,
															setPixCode,
															onPixConfirmed: handlePixConfirmedFromPayConfirm,
															onPixUnblock: unblockPixNavigation,
															showUpdateInfo: () => setShowUpdateInfo(!showUpdateInfo),
															showError: (msg) => {
																setErrorMessage(msg);
																setShowError(true);
															},
															offerAccepted,
														})
														.show();
												}
											}}
											style={{
												width: "100%",
												float: "left",
												marginRight: "1px",
												backgroundColor: "#672E37",
												color: "#fff",
												fontSize: "clamp(14px, 1vw, 18px)",
												fontWeight: 600,
												textTransform: "uppercase",
											}}
											className={classes.root}>
											{t("Make payment")}
										</Button>
									)}
								</Grid>
							) : (
								<div style={{ justifyContent: "space-evenly", width: "100%", display: "flex" }}>
									{!_.isNull(contract?.transaction_percentage) && (
										<Button
											onClick={() => {
												if (me && currency === "BRL") {
													const regex = /[0-9]/;
													const hasNumbersInName = regex.test(me?.name);
													if (hasNumbersInName) {
														setShowUserNameModal(true);
														return;
													}
													const validatePhone = validateAndHandlePhone("Cartão");
													if (validatePhone) {
														setShowPhoneModal(true);
														return;
													}
												}
												if (questions?.length > 0 && user && !user.isAnonymous && observation === "") {
													setErrorObservation(true);
													if (observationTextField && observationTextField.current) {
														observationTextField.current.focus();
													}
												} else {
													if (isOwnerUser) {
														const eventCreditProps = {
															...eventProps,
															Meio_De_Pagamento: "Cartão",
														};
														mixpanelTrackEvent("Definiu_Meio_De_Pagamento", eventCreditProps, currentUser, business);
													}
													setPix(null);
													setCardData(null);
													dialog
														.withContent(DialogAddCard)
														.withProps({
															setCardData,
														})
														.show();
												}
											}}
											style={{
												width: contract?.pix_transaction_percentage !== null ? "45%" : "100%",
												float: "left",
												marginRight: "1px",
											}}
											className={classes.buttonChoosePayment}>
											{t("Pay with card")}
										</Button>
									)}
									{!_.isNull(contract?.pix_transaction_percentage) && (
										<Button
											onClick={() => {
												if (me && currency === "BRL") {
													const regex = /[0-9]/;
													const hasNumbersInName = regex.test(me?.name);
													if (hasNumbersInName) {
														setShowUserNameModal(true);
														return;
													}
													const validatePhone = validateAndHandlePhone("Pix");
													if (validatePhone) {
														setShowPhoneModal(true);
														return;
													}
												}
												if (questions?.length > 0 && observation === "") {
													setErrorObservation(true);
													if (observationTextField && observationTextField.current) {
														observationTextField.current.focus();
													}
												} else {
													if (isOwnerUser) {
														const eventPixProps = {
															...eventProps,
															Meio_De_Pagamento: "Pix",
														};
														mixpanelTrackEvent("Definiu_Meio_De_Pagamento", eventPixProps, currentUser, business);
													}
													setPix(null);
													setCardData(null);
													dialog.withContent(DialogPix).withProps({ setPix }).show();
												}
											}}
											style={{
												width: contract?.transaction_percentage !== null ? "45%" : "100%",
												marginRight: "1px",
											}}
											className={classes.buttonChoosePayment}>
											{t("Pay with pix")}
										</Button>
									)}
								</div>
							)}
						</div>
					) : (
						<>
								{(!showLogin || (me?.name && verificationUserIsNotAnonymous)) && (
									<div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
										<Button
											disabled={loading || isProcessing || Object.values(serviceRecoveryState).some((r) => r?.status === "expired")}
											type="button"
											onClick={() => {
												if (!me || !me?.name || (!me?.phone && !me?.phoneUnverified) || !user || user.isAnonymous) {
													localStorage.setItem("@prit-web/showLogin", true);
													setShowLogin(true);
													return;
												}
												if (me && currency === "BRL") {
													const regex = /[0-9]/;
													const hasNumbersInName = regex.test(me?.name);
													const validatePhone = validateAndHandlePhone("");
													if (hasNumbersInName) {
														setShowUserNameModal(true);
														return;
													}
													if (validatePhone) {
														setShowPhoneModal(true);
														return;
													}
												}
														
												if (!schedulingServicePackage && checkoutInformation?.anticipation_payment_percentage > 0) {
													dialog
														.withContent(DialogDiscount)
														.withProps({
															acceptOffer: () => {
																setOfferAccepted(true);
															},
															refuseOffer: (is_offer_refused) => {
																handleScheduleClickConfirm(is_offer_refused);
															},
															checkoutInformation,
															currency,
														})
														.show();
												} else {
													if (
														questions?.length > 0 &&
														observation === "" &&
														observationTextField.current
													) {
														setErrorObservation(true);
														if (observationTextField && observationTextField.current) {
															observationTextField.current.focus();
														}
													} else {
														handleScheduleClickConfirm();
													}
												}
											}}
											className={classes.buttonChooseLogin}
											style={{
												textTransform: "none",
												fontWeight: "Bold",
												backgroundColor: Object.values(serviceRecoveryState).some((r) => r?.status === "expired") ? "#B0B0B0" : "#672E37",
												color:"#fff",
												border: "none",
											}}>
										{t("Confirm Scheduling")}
									</Button>
									
									</div>
								)}

							{(showLogin && (!me?.name || !verificationUserIsNotAnonymous || authStatus === "SUCCESS")) && (
								<>
									<WhatsAppLoginButton
										successRoute={`/checkout/${business?.id}`}
										reloadOnSuccess={true}
										className={classes.buttonChooseLogin}
										style={{
											textTransform: "uppercase",
											fontWeight: "Bold",
											marginBottom: "5%",
											border: "none",
											height: 44,
											fontSize: 'clamp(14px, 1vw, 18px)',
											backgroundColor: "#672E37",
											color: "#fff",
											opacity: whatsAppLoading ? 0.5 : 1
										}}
										onLoadingChange={setWhatsAppLoading}
										language={i18n?.language || "pt-BR"}
										label={t("verify with whatsapp")}
										goBackRouteProps={props.location.state ? { ...props.location.state, slotChecked: false } : undefined}
										checkoutInformation={checkoutInformation}
										schedulingServicePackage={schedulingServicePackage}
										questions={questions}
										observation={observation}
										onFinalizeAppointment={handleScheduleClickConfirm}
										observationTextField={observationTextField}
										setErrorObservation={setErrorObservation}
										onStartLoading={() => {
											setLoading(true);
											setIsProcessing(true);
										}}
										checkoutLoading={loading}
										showCustomLogin={true}
										showLoginGoogle={showLoginGoogle}
										business={business}
									/>
								</>
							)}
						</>
					)}
				</div>
				
			</>
		);
	};

	return (
		<>
			<TitleContainer
				handleClick={() => props.history.goBack()}
				imageVisible={true}
				footer={footer()}
				loading={loading}
				showGradient={false}
				backgroundNew={true}
				childrenStyle={{ padding: 0 }}
				showOpacityFooter={!verificationUserIsNotAnonymous && showLogin}
				rightElement={
					<div style={{ backgroundColor: "rgba(0,0,0,0.8)", borderRadius: 50, padding: "4px 10px" }}>
						<Typography style={{ fontSize: 16, color: "#fff", fontWeight: "300" }}>
							{t("{{actualStep}} of {{finishStep}}", {
								actualStep: startedLoggedOut && verificationUserIsNotAnonymous ? 5 : 4,
								finishStep: startedLoggedOut ? 5 : 4,
							})}
						</Typography>
					</div>
				}>
				<SEO business={business} page="Checkout" />
				<Grid container direction="column" style={{ Maxheight: "100vh", minHeight: "90vh", background: "transparent" }}>
				<div
					style={{
						marginTop: 40,
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
						alignItems: "center",
						paddingBottom: 20,
					}}>
						<Typography className={classes.titlePage} style={colorTextContrast ? { color: colorTextContrast } : undefined}>{t("Review and complete your appointment")}</Typography>
				</div>
					<div
						style={{
							marginTop: 100,
							display: "flex",
							flexDirection: "column",
							justifyContent: "center",
							alignItems: "center",
							marginBottom: 20,
						}}>
						{laterPayment && (
							<Typography className={classes.titlePage}>{t("Complete your payment")}</Typography>
						)}
					</div>
					<ModalBottom
						animationType="slideRight"
						style={{
							maxWidth: "480px",
							margin: "0 auto",
							width: "100%",
							flex: 1,
							position: "relative",
						}}
						childrenStyle={{
							paddingBottom: "200px",
						}}
						>
						<div>
							<div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginBottom: 10 }}>
								<Typography style={{ fontSize: "clamp(20px, 2vw, 24px)", fontWeight: 600 }}>{business?.name}</Typography>
							</div>
							{/* de ponta a ponta: compensa o padding de 20px do ModalBottom */}
							<Divider style={{ margin: "0 -20px 10px" }} />
							{effectiveServices?.length > 0 &&
								effectiveServices
									.map((service, originalIndex) => ({ service, originalIndex }))
									.filter(
										({ service }) =>
											!selectedPackages?.length ||
											!selectedPackages.some((pkg) => pkg.body?.bookings[0]?.service_id === service?.service_id)
									)
									.map(({ service, originalIndex }, renderIndex) => {
										const recovery = serviceRecoveryState[originalIndex];
										const isExpired = recovery?.status === "expired";
										const isUpdated = recovery?.status === "updated";
										const allSlots = recovery?.alternativeSlots || [];
										const expiredCardProps = isExpired
											? {
													expiredTimeLabel: formatTime(
														dayjs(service.date).utc().tz(business?.timeZone).format("HH:mm")
													),
													dayLabel: dayjs(service.date)
														.utc()
														.tz(business?.timeZone)
														.format(formatDateByLanguage?.dayMonth),
													loadingSlots: recovery.loadingSlots,
													hasFeatureItems: recovery.hasFeatureItems,
													slots: recovery.expandedAllSlots ? allSlots : allSlots.slice(0, 3),
													hasMoreSlotsThisDay: !recovery.expandedAllSlots && allSlots.length > 3,
													timeZone: business?.timeZone,
													onSelectSlot: (slot) => handleSelectAlternativeSlot(originalIndex, slot),
													onSeeAllThisDay: () => handleSeeAllThisDay(originalIndex),
													onSeeOtherDay:
														(service?.service?.featureItems || recovery.errorMessage)
															? () => handleSeeOtherDay(originalIndex)
															: undefined,
												errorMessage: recovery.errorMessage || null,
												serviceName: business?.name,
												advanceNoticeMinutes: business?.earlyBooking?.minutes,
											  }
											: undefined;
										const isSessionCovered = sessionsAccepted?.some(
											(session) => session?.serviceId === service?.service_id
										);
										const serviceSessions = sessionsAccepted?.filter(
											(session) => session?.serviceId === service?.service_id
										);
										return (
											<React.Fragment key={`checkout-${originalIndex}`}>
												<ServiceItem
													service={service}
													index={renderIndex}
													totalServices={effectiveServices.length}
													checkoutInformation={checkoutInformation}
													currency={currency}
													viewUponConsultation={true}
													isExpired={isExpired}
													isUpdated={isUpdated}
													expiredCardProps={expiredCardProps}
													expiredTagLabel={recovery?.errorMessage ? t("unavailableTag") : undefined}
													priceStrikethrough={isSessionCovered || packageChoices[service?.service_id]?.type === "client"}
												/>
												{/* REQ-05: escolha feita no sheet de pacote antes do checkout */}
												{packageChoices[service?.service_id] && (() => {
													const choice = packageChoices[service.service_id];
													if (choice.type === "avulso") {
														return (
															<div style={{ fontSize: 13, color: "#888", marginBottom: 8, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
																<span>{t("checkout_review_paying_service")}</span>
																<button
																	onClick={() => setTrocarServiceId(service.service_id)}
																	style={{ background: "transparent", border: "none", cursor: "pointer", fontFamily: "inherit", fontSize: 13, fontWeight: 700, color: business?.primaryColor || "#672E37", padding: 0 }}>
																	{t("checkout_review_change")}
																</button>
															</div>
														);
													}
													const display = choice.display || {};
													return (
														<LinhaPacote
															nome={display.nome}
															total={display.total}
															feitas={display.feitas}
															valeAte={display.valeAte}
															// sem política ativa, pacote pendente não é cobrado aqui
														aberto={!display.pago && isPolicyActive}
															novo={display.novo}
															card={true}
															acao={t("checkout_review_change")}
															onAcao={() => setTrocarServiceId(service.service_id)}
															businessColor={business?.primaryColor}
														/>
													);
												})()}
												{isSessionCovered && serviceSessions?.length > 0 && !packageChoices[service?.service_id] && (
													<CheckoutSessionPackageContainer
														sessionsAccepted={serviceSessions}
														onSwitch={() => openPackageModalQueue()}
														isPending={isSessionPending}
													/>
												)}
											</React.Fragment>
										);
									})}
							{isSessionPending && (() => {
								const pendingInfo = sessionsAccepted[0]?.infoPackage;
								const totalPrice = pendingInfo?.packageTotalPrice ?? 0;
								const packageName = pendingInfo?.packageName || "";
								const qty = pendingInfo?.packageQuantity ?? 0;
								return (
									<div style={{
										background: "#FFF0F2",
										border: "1px solid #EBD3D8",
										borderRadius: 12,
										padding: "12px 13px",
										marginBottom: 12,
									}}>
										<div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
											<span style={{ fontSize: 14, fontWeight: 700, color: "#672E37" }}>
												{t("checkout_session_pending_package_title")}
											</span>
											<span style={{ fontSize: 16, fontWeight: 800, color: "#672E37" }}>
												{Utils.formatMoney(totalPrice / 100, currency)}
											</span>
										</div>
										<div style={{ fontSize: 12.5, color: "#7A4A55", marginTop: 6, lineHeight: 1.4 }}>
											{t("checkout_session_pending_package_description", { packageName, others: qty - 1 })}
										</div>
									</div>
								);
							})()}
							{declinedPackageCard && (
								<div style={{
									background: "#fff",
									border: "1px solid #DDD8CE",
									borderRadius: 12,
									padding: "12px 13px",
									marginBottom: 14,
									display: "flex",
									alignItems: "flex-start",
									gap: 10,
								}}>
									<svg width="17" height="17" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0, marginTop: 2 }}>
										<path d="M3.5 7.5L12 3.5l8.5 4v9L12 20.5l-8.5-4v-9z" stroke="#672E37" strokeWidth="1.8" strokeLinejoin="round" />
										<path d="M3.5 7.5L12 11.6l8.5-4.1M12 11.6v8.9" stroke="#672E37" strokeWidth="1.8" strokeLinejoin="round" />
									</svg>
									<div style={{ flex: 1, minWidth: 0 }}>
										<div style={{ fontSize: 13.5, fontWeight: 700, color: "#2B2B30", lineHeight: 1.3 }}>
											{t("checkout_session_declined_title", { serviceName: declinedPackageCard.serviceName })}
										</div>
										<div style={{ fontSize: 12.5, color: "#6B6B72", marginTop: 3, lineHeight: 1.35 }}>
											{t("checkout_session_declined_subtitle")}
										</div>
										<button
											onClick={declinedPackageCard.onUse}
											style={{
												background: "transparent",
												border: "none",
												padding: "8px 0 0",
												cursor: "pointer",
												fontFamily: "inherit",
												fontSize: 12.5,
												fontWeight: 700,
												color: "#672E37",
											}}>
											{t("checkout_session_declined_cta")}
										</button>
									</div>
								</div>
							)}
							{/* selectedPackages: layout do protótipo — serviço + profissional + LinhaPacote */}
							{selectedPackages?.length > 0 && selectedPackages.map((pkgData, pkgIdx) => {
								const serviceName = pkgData.info?.serviceName;
								const serviceRegularPrice = pkgData.serviceLinkedPackage?.service?.price ?? 0;
								const professional = pkgData.serviceLinkedPackage?.professional;
								const dateStart = pkgData.serviceDateTime?.start_time;
								const duration = pkgData.info?.duration || professional?.duration || 0;
								const packageName = pkgData.info?.packageName;
								const total = pkgData.info?.quantity || 0;
								const validity = pkgData.info?.validity;
								const valeAte = validity
									? formatDateDDMMYYYY(dayjs().add(validity, "day").toISOString(), i18n.language)
									: null;
								const INK = "#2B2B30";
								const BODY = "#6B6B72";
								// mesmo formato de data/hora do ServiceItem (avulso)
								const when = dateStart ? dayjs(dateStart).utc().tz(business?.timeZone) : null;
								const dateStr = when
									? t("checkout_review_date_time", {
											date: when.format(formatDateToLanguage().dayMonth),
											time: formatTime(when.format("HH:mm")),
									  })
									: null;
								return (
									<React.Fragment key={`sel-pkg-${pkgIdx}`}>
										{pkgIdx > 0 && <Divider style={{ margin: "12px 0" }} />}
										{/* Serviço + preço */}
										<div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
											<Typography style={{ fontWeight: 700, fontSize: 16, color: INK }}>
												{serviceName}
											</Typography>
											{serviceRegularPrice > 0 && (
												<Typography style={{ fontSize: 15, flexShrink: 0, marginLeft: 8, color: BODY, textDecoration: "line-through" }}>
													{Utils.formatMoney(serviceRegularPrice / 100, currency)}
												</Typography>
											)}
										</div>
										{/* Profissional + data/hora */}
										{professional && (
											<div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
												<Avatar
													variant="circle"
													src={professional.avatarUrl || ""}
													style={{ width: 28, height: 28, fontSize: 12, backgroundColor: "#EEEEEE", color: "#555" }}>
													{!professional.avatarUrl && getInitials(professional.name || "")}
												</Avatar>
												<div>
													<Typography style={{ fontSize: 13.5, fontWeight: 600, color: INK, lineHeight: 1.2 }}>
														{professional.name}
													</Typography>
													{(dateStr || duration) && (
														<div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
															{dateStr && (
																<Typography style={{ fontSize: 12.5, color: BODY }}>{dateStr}</Typography>
															)}
															{duration > 0 && (
																<>
																	<img src={timeIcon} alt="" style={{ width: 12, height: 12, margin: "0 4px 0 8px" }} />
																	<Typography style={{ fontSize: 12.5, color: BODY }}>
																		{Utils.formatMinutes(duration).trim()}
																	</Typography>
																</>
															)}
														</div>
													)}
												</div>
											</div>
										)}
										<Divider style={{ marginBottom: 12 }} />
										{/* Card do pacote ou linha avulso */}
										<LinhaPacote
											nome={packageName}
											total={total}
											feitas={0}
											valeAte={valeAte}
											aberto={true}
											novo={true}
											card={true}
											acao={pkgData.checkoutService ? t("checkout_review_change") : null}
											onAcao={() => setTrocarSelectedPkgIdx(pkgIdx)}
											businessColor={business?.primaryColor}
										/>
										<Typography style={{ fontSize: 12.5, color: "#888", marginTop: 6, textAlign: "center" }}>
											{t("package_offer_pay_now_note", { price: Utils.formatMoney((pkgData.info?.packagePrice || 0) / 100, currency) })}
										</Typography>
									</React.Fragment>
								);
							})}
							{/* REQ-05: Pagar agora / Restante no local quando há pacote na revisão */}
							{hasPackageReview ? (
								(() => {
									// Compras de pacote (selectedPackages) + pacote pendente + sinal dos avulsos
									const pkgTotal = (selectedPackages || []).reduce(
										(sum, pkg) => sum + (pkg.info?.packagePrice || 0),
										0
									) / 100;
									const servicesForCalc = effectiveServices.map((svc) => {
										const fullPrice = svc.service?.servicePrice || svc.professional?.price || 0;
										const isSinalPricing = svc?.professional?.pricingType === "sinal";
										return {
											id: svc.service_id,
											price: fullPrice,
											sinal: isSinalPricing ? (svc.professional?.price || 0) : fullPrice,
										};
									});
									const review = calculateReviewValues(servicesForCalc, packageChoices, {
										chargePendingPackages: isPolicyActive,
									});
									const pagarAgora = Math.round((pkgTotal + review.pagarAgora) * 100) / 100;
									const restanteNoLocal = review.restanteNoLocal;
									// tudo pago com pacote e sem política ativa: não há valor nem regra a mostrar
									if (pagarAgora <= 0 && restanteNoLocal <= 0 && !isBusinessPolicyActive && !(selectedPackages?.length > 0)) return null;
									return (
										<div style={{ padding: "8px 0", marginBottom: 8 }}>
											{/* de ponta a ponta: compensa o padding de 20px do ModalBottom */}
											<Divider style={{ margin: "8px -20px 12px" }} />
											{pagarAgora > 0 && (
												<div style={{ display: "flex", justifyContent: "space-between", fontSize: 14, color: "#333", padding: "4px 0" }}>
													<span style={{ fontWeight: 600 }}>{t("Pay now")}</span>
													<span style={{ fontWeight: 700 }}>{Utils.formatMoney(pagarAgora, currency)}</span>
												</div>
											)}
											{restanteNoLocal > 0 && (
												<div style={{ display: "flex", justifyContent: "space-between", fontSize: 14, color: "#888", padding: "4px 0" }}>
													<span>{t("Pay at location")}</span>
													<span>{Utils.formatMoney(restanteNoLocal, currency)}</span>
												</div>
											)}
											{/* compra de pacote é sempre paga antes: a política vale mesmo sem cobrança antecipada no negócio */}
											{(isBusinessPolicyActive || selectedPackages?.length > 0) && (
												<Typography style={{ fontSize: 12, color: "#888", marginTop: 8 }}>
													{packageCancellationMessage}
												</Typography>
											)}
										</div>
									);
								})()
							) : (
								checkoutInformation && !hasOnlyPackageSessions && (
									<PaymentSummary
										checkoutInformation={checkoutInformation}
										payload={{ services: sessionsAccepted?.length > 0 ? standaloneServices : services }}
										couponValue={coupon}
										totalPricingType={totalPricingType}
										currency={currency}
										offerAccepted={offerAccepted}
										laterPayment={laterPayment}
										postPayment={postPayment}
										sessionsAccepted={sessionsAccepted}
									/>
								)
							)}
						</div>
						{user && !user.isAnonymous && !postPayment && questions?.length > 0 && (
							<div style={{ padding: "10px", paddingBottom: "20px" }}>
								<div style={{ display: "flex" }}>
									<ChatIcon className={classes.observationIcon}></ChatIcon>
									<div style={{ width: "82%" }}>
										<Typography className={classes.question}>
											{questions[0]?.question?.split(" ").map((word) => {
												if (word.length >= 4 && word.substring(0, 4) == "http") {
													return (
														<a className={classes.questionLink} onClick={() => window.open(word)}>
															{word + " "}
														</a>
													);
												} else {
													return word + " ";
												}
											})}
										</Typography>
									</div>
								</div>
								<div style={{ position: "relative" }}>
									<Typography
										style={{ color: characterCount >= 300 ? "red" : "", position: "absolute", right: 0, bottom: 0 }}
										className={classes.characterCount}>
										{characterCount}/300
									</Typography>
									<TextField
										inputRef={observationTextField}
										multiline
										id="outlined-basic"
										variant="outlined"
										className={classes.observation}
										InputProps={{ style: { borderRadius: 10 } }}
										value={observation}
										onChange={handleObservation}
										error={errorObservation}
										helperText={errorObservation ? t("Mandatory answer") : " "}
									/>
								</div>
							</div>
						)}
					</ModalBottom>
				</Grid>
			</TitleContainer>
			<ModalPaymentProcessing
				open={showPaymentProcessingModal}
				onClose={() => setShowPaymentProcessingModal(false)}
			/>
			<ModalPhoneNumber
				open={showPhoneModal}
				onClose={() => {
					setShowPhoneModal(false);
					window.location.reload();
				}}
				titleKey={phoneModalConfig.titleKey}
				messageKey={phoneModalConfig.messageKey}
			/>
			<ModalUserName
				open={showUserNameModal}
				onClose={() => {
					setShowUserNameModal(false);
					if (openModalCustom === "REGISTER_NAME_USER") {
						setAuthStatus("SUCCESS");
					}
				}}
				titleKey="Complete your name"
				messageKey="We need your name to complete your registration"
			/>
			{trocarServiceId !== null && (() => {
				const trocarSvc = effectiveServices?.find((s) => s.service_id === trocarServiceId);
				if (!trocarSvc) return null;
				return (
					<PackageOfferModal
						open={true}
						onClose={() => setTrocarServiceId(null)}
						recommendedPackages={purchaseOffersFor(trocarSvc.service_id)}
						services={[
							{
								id: trocarSvc.service_id,
								name: trocarSvc.service?.serviceName,
								price: trocarSvc.service?.servicePrice,
							},
						]}
						servicesFormatted={[
							{
								service: { id: trocarSvc.service_id },
								professional: trocarSvc.professional,
								professional_id: trocarSvc.professional_id,
								time: { start: trocarSvc.date },
								dateStart: trocarSvc.date,
							},
						]}
						currentServiceIndex={0}
						currency={currency}
						clientPackages={rawClientPackages}
						onChoose={(choice) => {
							setTrocarServiceId(null);
							applyPackageChoiceChange(trocarSvc.service_id, choice);
						}}
					/>
				);
			})()}
			{trocarSelectedPkgIdx !== null && (() => {
				const pkgData = selectedPackages?.[trocarSelectedPkgIdx];
				const checkoutService = pkgData?.checkoutService;
				if (!checkoutService) return null;
				return (
					<PackageOfferModal
						open={true}
						onClose={() => setTrocarSelectedPkgIdx(null)}
						recommendedPackages={purchaseOffersFor(checkoutService.service_id)}
						services={[
							{
								id: checkoutService.service_id,
								name: checkoutService.service?.serviceName,
								price: checkoutService.service?.servicePrice,
							},
						]}
						servicesFormatted={[
							{
								service: { id: checkoutService.service_id },
								professional: checkoutService.professional,
								professional_id: checkoutService.professional_id,
								time: { start: checkoutService.date },
								dateStart: checkoutService.date,
							},
						]}
						currentServiceIndex={0}
						currency={currency}
						clientPackages={rawClientPackages}
						onChoose={(choice) => {
							const idx = trocarSelectedPkgIdx;
							setTrocarSelectedPkgIdx(null);
							applyPackageChoiceChange(checkoutService.service_id, choice, { fromPackageIdx: idx });
						}}
					/>
				);
			})()}
			{packageModalQueue.length > 0 && packageModalQueueIndex < packageModalQueue.length && (() => {
				const currentItem = packageModalQueue[packageModalQueueIndex];
				const advanceQueue = (wasAccepted) => {
					const nextDeclinedCount = packageModalDeclinedCount + (wasAccepted ? 0 : 1);
					const nextIndex = packageModalQueueIndex + 1;
					if (nextIndex < packageModalQueue.length) {
						setPackageModalQueueIndex(nextIndex);
						setPackageModalDeclinedCount(nextDeclinedCount);
					} else {
						setPackageModalQueue([]);
						setPackageModalQueueIndex(0);
						setPackageModalDeclinedCount(0);
						if (nextDeclinedCount > 0) setUserDeclinedPackage(true);
					}
				};
				return (
					<CheckoutSessionPackageModal
						open={true}
						sessions={currentItem.sessions}
						service={currentItem.service}
						currentStep={packageModalQueueIndex + 1}
						totalSteps={packageModalQueue.length}
						currency={currency}
						onUsePackage={() => {
							advanceQueue(true);
						}}
						onSkip={() => {
							advanceQueue(false);
						}}
					/>
				);
			})()}
		</>
	);
};

export default withRouter(Checkout);
